import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPocketcastsComponent } from './simple-icons-pocketcasts.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPocketcastsComponent ],
    exports:      [ SimpleIconsPocketcastsComponent ],
    bootstrap:    []
})
export class SimpleIconsPocketcastsModule {}
